export enum promoConditionsContractType {
    ENERGY = "ENERGY"
}